import React, { HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";
import BuyNowTextBox from "components/textBoxes/buyNow/BuyNowTextBox";
import Rotate from "components/rotate/Rotate";
import Scribble from "components/scribble/Scribble";

const useStyles = makeStyles((theme: Theme) => {
    const imageContainerZIndex = 10;

    return createStyles({
        root: {
            display: "flex",
            [theme.breakpoints.down("sm")]: {
                flexDirection: "column",
                maxWidth: 600,
            },
        },
        imageContainer: {
            flex: 1,
            display: "flex",
            alignItems: "center",
            zIndex: imageContainerZIndex,
        },
        textbox: {
            flex: 1,
            display: "flex",
            alignItems: "center",
            marginLeft: -theme.spacing(2),
            zIndex: imageContainerZIndex - 1,
            [theme.breakpoints.down("sm")]: {
                marginTop: -theme.spacing(3),
                marginLeft: theme.spacing(2),
                zIndex: imageContainerZIndex + 1,
            },
        },
        scribbleContainer: {
            width: "75%",
            height: "auto",
            top: "-16%",
            left: "-23%",
            [theme.breakpoints.down("sm")]: {
                width: "75%",
                height: "auto",
                bottom: "-12%",
                left: "-15%",
                top: "unset",
            },
        },
    });
});

interface IProps extends HTMLAttributes<HTMLDivElement> {
    keyartSrc: string;
}

export default function Addon(props: IProps) {
    const classes = useStyles();
    const { keyartSrc, className, children, ...rest } = props;

    return (
        <div className={clsx(className, classes.root)} {...rest}>
            <div className={classes.imageContainer}>
                <img src={keyartSrc} style={{ width: "100%" }} />
            </div>
            <Rotate amount={-1} className={classes.textbox}>
                <Scribble
                    variant="v2"
                    classes={{
                        scribbleContainer: classes.scribbleContainer,
                    }}
                >
                    <BuyNowTextBox>{children}</BuyNowTextBox>
                </Scribble>
            </Rotate>
        </div>
    );
}
